import { useImmerAtom } from 'jotai-immer';
import { tableViewAtom, tableFiltersAtom, tableStatsAtom, payorDataAtom } from '../payor_list_atoms';
import { PayorDataHook } from '../payor_list_types';
import { useTableData } from '../../../../core/table/hooks/useTableData';

export const usePayorData = (): PayorDataHook => {
    const [view] = useImmerAtom(tableViewAtom);
    const [filters] = useImmerAtom(tableFiltersAtom);
    const [stats, setStats] = useImmerAtom(tableStatsAtom);
    const [data] = useImmerAtom(payorDataAtom);

    const { items } = useTableData({ view, filters, stats, data, setStats });

    return { items };
};
